<template>
  <div style="display: contents">
    <tr>
      <td colspan="3"></td>
      <td>
        <b-iconstack  @click="collapsed = !collapsed"
          v-b-tooltip.hover.top :title=" collapsed ? 'mai putin' :'mai mult'"
          :class="collapsed ? 'text-danger' : ''">
          <b-icon stacked icon="square"></b-icon>
          <b-icon stacked
            :icon="collapsed ? 'dash' : 'plus'"
          />
        </b-iconstack>
      </td>
      <td colspan="7">
        <span class="font-weight-bold text-primary">{{ item.description }}</span>
      </td>
    </tr>
    <template v-if="collapsed">
      <BookingItemResult
        v-for="(subitem, itemIndex) in item.items"
        :item="subitem"
        :is_tour="item.is_tour"
        :booking="booking"
        :key="'pitem' + itemIndex" />
    </template>
  </div>
</template>

<script>
import BookingItemResult from './booking_item_result'

export default {
  name: 'PackageItemResult',
  props: ['item', 'booking'],
  components: { BookingItemResult },
  data () { return { collapsed: false } }
}
</script>
